import { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { App as AntdApp } from 'antd'
import { router } from './router'
import { setMsg } from './utils/msgHolder'

function App() {
  const { message } = AntdApp.useApp()

  useEffect(() => {
    setMsg(message)
  }, [message])

  return <RouterProvider router={router} />
}

export default App
